// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2HImH","title":"Header_title__2lCJi","left":"Header_left__37mu3","clinicName":"Header_clinicName__1sNMn"};